// Centralized theme for Hexcrawl hand-drawn aesthetic

export const PALETTE = {
  parchment: {
    light: '#fffef0',
    medium: '#f4ece0',
    dark: '#e8dcc8',
  },
  ink: {
    black: '#2a2520',
    brown: '#5c4a3d',
    sepia: '#704214',
    faded: '#8b7355',
  },
  accent: {
    amber: '#d4a574',
    success: '#5a8a5a',
    warning: '#c4956a',
  },
  archetype: {
    tomb: '#8b7355',
    temple: '#a08060',
    cave: '#6a7a6a',
    fortress: '#7a7a7a',
    lair: '#856a5a',
  },
  desire: {
    needsLabel: 'rgba(212, 165, 116, 0.4)',
    wantsConnection: 'rgba(150, 130, 100, 0.3)',
  }
};

export const TYPOGRAPHY = {
  handwritten: "'Caveat', cursive",
  ui: "'Segoe UI', system-ui, sans-serif",
};

export const ROUGH_PRESETS = {
  userRoom: {
    roughness: 0.8,
    bowing: 0.3,
    strokeWidth: 2,
  },
  generatedRoom: {
    roughness: 0.6,
    bowing: 0.2,
    strokeWidth: 1.5,
  },
  corridor: {
    roughness: 0.6,
    bowing: 0.3,
    strokeWidth: 1.5,
  },
};

// Archetype display names
export const ARCHETYPE_NAMES: Record<string, string> = {
  tomb: 'Ancient Tomb',
  temple: 'Sacred Temple',
  cave: 'Natural Cave',
  fortress: 'Fortified Stronghold',
  lair: "Monster's Lair",
};
